module.exports = __webpack_public_path__ + "static/flags/EK-475e0e1ed897f74c2a45735a9b50f31a.gif";